import { render, staticRenderFns } from "./contractTab.vue?vue&type=template&id=86bd8722&scoped=true&"
import script from "./contractTab.vue?vue&type=script&lang=js&"
export * from "./contractTab.vue?vue&type=script&lang=js&"
import style0 from "./contractTab.vue?vue&type=style&index=0&id=86bd8722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bd8722",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCardTitle,VCol,VRow,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})
